import React from 'react'
import { Card, CardHeader, CardTitle, CardBody, DataRow } from '../../../Card'
import { Icon } from '../../../../atoms/Icon'
import { Badge } from '../../../../atoms/Badge'
import type { LandInfoProps } from '../../LandSection.types'
import { InfoGrid, BooleanIndicator } from './LandInfo.styles'

export const LandInfo: React.FC<LandInfoProps> = ({
  egridNumber,
  plotNumber,
  type,
  area,
  officialArea,
  isBuildable,
  hasBuildingArea,
  isDistinctPermanentRight,
  className,
  t,
}) => {
  const formatArea = (value?: number) =>
    value ? `${value.toLocaleString()} m²` : t('common.notAvailable')

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{t('info.title')}</CardTitle>
      </CardHeader>
      <CardBody>
        <InfoGrid>
          <DataRow
            label={t('info.egridNumber')}
            value={egridNumber || t('common.notAvailable')}
          />

          <DataRow
            label={t('info.plotNumber')}
            value={plotNumber || t('common.notAvailable')}
          />

          {type && <DataRow label={t('info.type')} value={type} />}

          <DataRow label={t('info.area')} value={formatArea(area)} />

          {officialArea && officialArea !== area && (
            <DataRow
              label={t('info.officialArea')}
              value={formatArea(officialArea)}
            />
          )}

          <DataRow
            label={t('info.buildable')}
            value={
              <BooleanIndicator $value={isBuildable}>
                <Icon
                  name={isBuildable ? 'check-circle' : 'x-circle'}
                  size="small"
                />
                {isBuildable ? t('common.yes') : t('common.no')}
              </BooleanIndicator>
            }
          />

          <DataRow
            label={t('info.buildingAreaPresent')}
            value={
              <BooleanIndicator $value={hasBuildingArea}>
                <Icon
                  name={hasBuildingArea ? 'check-circle' : 'x-circle'}
                  size="small"
                />
                {hasBuildingArea ? t('common.yes') : t('common.no')}
              </BooleanIndicator>
            }
          />

          <DataRow
            label={t('info.propertyNature')}
            value={
              <Badge
                variant={isDistinctPermanentRight ? 'warning' : 'default'}
                size="small"
              >
                {isDistinctPermanentRight
                  ? t('info.propertyNatureDDP')
                  : t('info.propertyNatureBF')}
              </Badge>
            }
          />
        </InfoGrid>
      </CardBody>
    </Card>
  )
}
